import { useMutation } from "@tanstack/react-query";
import type { CustomerBankStatementUploadsSchemas } from "@wayflyer/api-types";
import { useAxios } from "@wayflyer/auth-sdk";

import { BANK_STATEMENTS_SUBMIT_API, BANK_STATEMENTS_SUBMIT_BY_UUID_API } from "../../components/constants";

export interface StatementUploadsSubmission {
  object_keys: string[];
  group: string;
}

export const useBankStatementSubmitMutation = (customerDomain: string) => {
  const client = useAxios();
  const mutationUrl = BANK_STATEMENTS_SUBMIT_API.replace(":customerSlug", customerDomain);
  return useMutation({
    mutationFn: (data: StatementUploadsSubmission) => {
      return client.post(mutationUrl, data);
    },
  });
};

export const useBankStatementSubmitByUuidMutation = (customerDomain: string) => {
  const client = useAxios();
  const mutationUrl = BANK_STATEMENTS_SUBMIT_BY_UUID_API.replace(":customerSlug", customerDomain);
  return useMutation({
    mutationFn: (data: CustomerBankStatementUploadsSchemas.SubmitBankStatementUploadsByUuidSchema) => {
      return client.post(mutationUrl, data);
    },
  });
};
